import { environment } from 'environments';

(() => {
  class SmsController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Messages, Users, Auth) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Messages,
        Users,
        Auth,
        patientId: parseInt($scope.ngDialogData.patient, 10),
        messages: [],
        beforeCursor: null,
        afterCursor: null,
        POLL_INTERVAL: 5000,
      });
      $scope.$on('$destroy', () => $interval.cancel(this.pollingInterval));
      $scope.$on('ngDialog.opened', this.initChatbox.bind(this));
      this.getPatientDetails();
      this.getOlderMessages();
    }

    getPatientDetails() {
      // Manually set patient if it's a system message
      if (this.patientId === -1) {
        this.patient = {
          firstname: 'System',
          lastname: '',
        };
        return;
      }

      this.Users.getOne(this.patientId).then(({ data }) => {
        this.patient = data;
      });
    }

    getOlderMessages() {
      this.loading = true;
      this.Messages.getThread(this.patientId, {
        before: this.beforeCursor,
      })
        .then(({ data }) => {
          this.messages = this.messages.concat(data.data);
          this.metaData = data['metadata'];
          /*
                  // New API endpoint is still doing pagination BUT we don't get the pagination parameters anymore
                  // So we get them from the array of messages
                  if (this.metaData.pagination) {
                    this.beforeCursor = this.metaData.pagination.cursors.before;
                  }
        */

          var lastMessage = this.messages.length;

          if (lastMessage > 0) {
            this.beforeCursor = this.messages[lastMessage - 1].id;
          }

          this.startPollingMessages();
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }

    hasMoreMessages() {
      return this.metaData && this.messages.length < this.metaData.total;
    }

    sendMessage() {
      if (!this.message || !this.message.trim()) {
        return;
      }

      this.sending = true;
      this.Messages.sendTextMessage(
        this.patientId,
        'MESSAGE FROM NOREPLY@LEMONAID\n' + this.message,
        'sms',
        this.patient.cell,
      )
        .then(() => {
          this.markAsRead();
          this.messages.unshift({
            category_name: null,
            entry_type: 'sms',
            incoming: false,
            id: (this.messages.length && this.messages[0].id++) || 0,
            read: false,
            content: this.message,
            sent: new Date(),
            from: {
              id: this.Auth.profile.id,
              firstname: this.Auth.profile.firstname,
              lastname: this.Auth.profile.lastname,
            },
          });
          this.message = null;
          this.scrollChatbox();
        })
        .catch(() => {
          this.toastr.error('Failed to send message.');
        })
        .finally(() => {
          this.sending = false;
        });
    }

    markAsRead() {
      var unreadMessages = this.messages.filter(m => (m.from.id === this.patientId ? !m.read : false));

      if (unreadMessages.length) {
        this.marking = true;
        this.Messages.markThreadAsRead(this.patientId)
          .then(() => {
            _.each(unreadMessages, m => {
              m.read = true;
            });

            this.$rootScope.$broadcast('message-thread-read', this.patientId);
          })
          .catch(() => this.toastr.error('Failed to mark messages as read.'))
          .finally(() => {
            this.marking = false;
          });
      }
    }

    startPollingMessages() {
      // Get outta here if we're already polling
      if (this.pollingInterval) {
        return;
      }

      this.pollingInterval = this.$interval(() => {
        this.Messages.getThread(this.patientId, {
          after: this.afterCursor,
        }).then(({ data }) => {
          this.metaData = data['metadata'];
          /*
                      // New API endpoint is still doing pagination BUT we don't get the pagination parameters anymore
                      // So we get them from the array of messages
                      if (this.metaData.pagination) {
                        this.afterCursor = this.metaData.pagination.cursors.after;
                      }
          */

          if (this.messages.length > 0) {
            this.afterCursor = this.messages[0].id;
          }

          _.each(
            _.filter(data.data, m => {
              return m.id > this.messages[0].id && m.from.id === this.patientId;
            }),
            m => {
              this.messages.unshift(m);
              this.scrollChatbox();
            },
          );
        });
      }, this.POLL_INTERVAL);
    }

    initChatbox() {
      this.chatBox = $('.chat-modal .ngdialog-content')
        .draggable({
          // handle: '.dialog-header',
          handle: '.sms-handler',
          scroll: false,
        })
        .resizable({
          containment: 'parent',
          handles: 'se',
        });
    }

    scrollChatbox() {
      this.$timeout(() => {
        angular.element('.chat-box').stop().animate({
          scrollTop: 0,
        });
      });
    }
  }

  SmsController.$inject = ['$rootScope', '$scope', '$timeout', '$interval', 'toastr', 'Messages', 'Users', 'Auth'];
  angular.module('pims').controller('SmsController', SmsController);
})();
